(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  const roots = document.querySelectorAll('[data-comparison]');
  roots.forEach(function (root) {
    const viewport = root.querySelector('[data-comparison-viewport]');
    const track = root.querySelector('[data-comparison-track]');
    const cols = root.querySelectorAll('[data-comparison-col]');
    const nav = root.querySelector('[data-comparison-nav]');
    const dashesWrap = root.querySelector('[data-comparison-dashes]');
    const prev = root.querySelector('[data-comparison-prev]');
    const next = root.querySelector('[data-comparison-next]');
    if (!viewport || !track || !cols.length) return;

    const rows = ['pockets', 'best-for', 'weight', 'season', 'price', 'men', 'women'];

    function equalize() {
      const mobile = window.matchMedia('(max-width: 991px)').matches;
      root.querySelectorAll('[data-row="media"], [data-row="name"]').forEach(function (cell) {
        cell.style.minHeight = '';
        cell.style.height = '';
      });
      const syncRows = mobile ? rows : ['name'].concat(rows);
      syncRows.forEach(function (row) {
        const cells = root.querySelectorAll('[data-row="' + row + '"]');
        let max = 0;
        cells.forEach(function (cell) {
          cell.style.minHeight = '';
          max = Math.max(max, cell.offsetHeight);
        });
        cells.forEach(function (cell) {
          cell.style.minHeight = max + 'px';
        });
      });
    }

    function colWidth() {
      return cols[0] ? cols[0].getBoundingClientRect().width : 0;
    }

    let index = 0;
    let startX = 0;
    let startY = 0;
    let origin = 0;
    let lastX = 0;
    let lastT = 0;
    let velocity = 0;
    let grabbing = false;
    let dragged = false;

    function extraWidth() {
      const w = colWidth();
      if (!w) return 0;
      return Math.max(0, cols.length * w - viewport.offsetWidth);
    }

    function maxIndex() {
      const w = colWidth();
      if (!w) return 0;
      return Math.max(0, Math.ceil(extraWidth() / w - 0.01));
    }

    function offsetFor(i) {
      return Math.min(i * colWidth(), extraWidth());
    }

    function setOffset(x, animate) {
      track.classList.toggle('is-grabbing', !animate);
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function goTo(nextIndex) {
      index = Math.max(0, Math.min(maxIndex(), nextIndex));
      setOffset(-offsetFor(index), true);
      updateDashes();
    }

    let pinFrame = 0;
    let lastPin = '';

    function pinDashes() {
      if (pinFrame) return;
      pinFrame = window.requestAnimationFrame(function () {
        pinFrame = 0;
        applyPin();
      });
    }

    function applyPin() {
      if (!nav) return;
      if (!window.matchMedia('(max-width: 991px)').matches) {
        lastPin = '';
        nav.classList.remove('is-pinned', 'is-shown');
        nav.style.left = '';
        nav.style.width = '';
        return;
      }
      const box = viewport.getBoundingClientRect();
      const vh = window.innerHeight;
      const fromStart = vh - box.top;
      const atHome = box.bottom <= vh - 10;
      const inRange = fromStart >= 300 && box.bottom > 10;
      nav.classList.toggle('is-shown', inRange);
      if (!inRange || atHome) {
        lastPin = '';
        nav.classList.remove('is-pinned');
        nav.style.left = '';
        nav.style.width = '';
        return;
      }
      const left = Math.round(box.left);
      const width = Math.round(box.width);
      const key = left + ':' + width;
      nav.classList.add('is-pinned');
      if (key === lastPin) return;
      lastPin = key;
      nav.style.left = left + 'px';
      nav.style.width = width + 'px';
    }

    function currentIndex() {
      return index;
    }

    function renderDashes() {
      if (!dashesWrap || !nav) return;
      nav.hidden = false;
      if (window.matchMedia('(min-width: 992px)').matches || maxIndex() < 1) {
        nav.setAttribute('data-hide-desktop', '');
        dashesWrap.innerHTML = '';
        return;
      }
      nav.removeAttribute('data-hide-desktop');
      dashesWrap.innerHTML = '';
      const pages = maxIndex() + 1;
      for (let i = 0; i < pages; i++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'comparison__dash';
        button.setAttribute('aria-label', String(i + 1));
        button.addEventListener('click', function () {
          goTo(i);
        });
        dashesWrap.appendChild(button);
      }
      updateDashes();
    }

    function updateDashes() {
      if (!dashesWrap) return;
      const active = currentIndex();
      dashesWrap.querySelectorAll('.comparison__dash').forEach(function (dash, i) {
        dash.classList.toggle('is-active', i === active);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    function onStart(x, y) {
      if (window.matchMedia('(min-width: 992px)').matches) return;
      grabbing = true;
      dragged = false;
      startX = lastX = x;
      startY = y || 0;
      origin = -offsetFor(index);
      lastT = Date.now();
      velocity = 0;
      setOffset(origin, false);
    }

    function onMove(x, y) {
      if (!grabbing) return;
      const dx = x - startX;
      const dy = (y || 0) - startY;
      if (Math.abs(dx) > 6) dragged = true;
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) return;
      const now = Date.now();
      velocity = (x - lastX) / Math.max(1, now - lastT);
      lastX = x;
      lastT = now;
      const min = -extraWidth();
      let pos = origin + dx;
      if (pos > 0) pos *= 0.32;
      if (pos < min) pos = min + (pos - min) * 0.32;
      setOffset(pos, false);
    }

    function onEnd() {
      if (!grabbing) return;
      grabbing = false;
      const w = colWidth() || 1;
      const dx = lastX - startX;
      let next = index;
      if (velocity < -0.35 || dx < -w * 0.18) next += 1;
      else if (velocity > 0.35 || dx > w * 0.18) next -= 1;
      goTo(next);
    }

    track.addEventListener('touchstart', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      onStart(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!grabbing || !e.changedTouches || !e.changedTouches[0]) return;
      const x = e.changedTouches[0].clientX;
      const y = e.changedTouches[0].clientY;
      if (Math.abs(x - startX) > Math.abs(y - startY)) e.preventDefault();
      onMove(x, y);
    }, { passive: false });
    track.addEventListener('touchend', onEnd);
    track.addEventListener('touchcancel', onEnd);

    track.addEventListener('mousedown', function (e) {
      if (window.matchMedia('(min-width: 992px)').matches) return;
      onStart(e.clientX, e.clientY);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!grabbing) return;
      onMove(e.clientX, e.clientY);
    });
    window.addEventListener('mouseup', onEnd);

    track.addEventListener('click', function (e) {
      if (!dragged) return;
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }, true);

    window.addEventListener('resize', function () {
      equalize();
      renderDashes();
      if (window.matchMedia('(min-width: 992px)').matches) {
        index = 0;
        track.style.transform = '';
        track.classList.remove('is-grabbing');
        pinDashes();
        return;
      }
      goTo(index);
      pinDashes();
    });
    window.addEventListener('scroll', pinDashes, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', pinDashes);
      window.visualViewport.addEventListener('scroll', pinDashes);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        equalize();
        renderDashes();
        pinDashes();
      });
    }
    equalize();
    renderDashes();
    pinDashes();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi_gallery"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi_gallery_new"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
